<form action="" [formGroup]="cloudPOSForms" (ngSubmit)="onTransaction()">

  <div class="form-row" style="row-gap: 7px;margin-top: 11px;" >
    <div class="col-md-3" *ngIf="selectedPayaOption== '2'">
      <div class="form__div  mb-0 col-12 px-0">
        <ng-select class="ng-expiry-time" [items]="ppdOrCcdOptionsArray" bindValue="name" bindLabel="displayName" [clearable]="false"
          [searchable]="false" [multiple]="false" placeholder="Select sec code" notFoundText="No sec code selected" formControlName="terminalType">
        </ng-select>
      </div>
      <div class="error-message" *ngIf="(cloudPOSForms.get('terminalType')?.dirty || cloudPOSForms.get('terminalType')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'"
          *ngIf="cloudPOSForms.get('terminalType')?.invalid">
          <span *ngIf="cloudPOSForms.get('terminalType')?.errors.required" class="error-message">Sec Code is required
          </span>
        </ngb-alert>
      </div>
    </div>

    <div class="col-md-3 " style="height: 54px;">
      <div class="form__div col-12 px-0">
        <ng-select class="ng-expiry-time" [items]="accountTypeList" bindValue="name" bindLabel="name" [clearable]="false"
          [searchable]="false" [multiple]="false" placeholder="Select account type" notFoundText="No accountType selected" [readonly]="isMaskedCard" formControlName="accountType"  >
        </ng-select>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form__div mb-0 col-12 ">
    
        <input type="text" name="routingNumber" class="form__input" placeholder=" " formControlName="routingNumber"
          autocomplete="off" mask="{{maskedRoutingFormat}}" maxlength="9" (focus)="verifyAndOpenExistingCardsInfo('routing')" [readOnly]="isMaskedCard">
        <label class="form__label" for="routingNumber">
          <h6>{{'htmlText.routingNumber' | translate}}* </h6>
        </label>
        <div class="input-group-prepend justify-content-end  row" style="padding-top: 12px;" *ngIf="isMaskedCard">
          <p type="button" (click)="getConsumersTokenDetail()"
            class=" col-md-3 font-weight-bold cancel-btn text-right px-0" *ngIf="cardsLength > 1">Cards
          </p>
          <p type="button" class="mdi mdi-close-circle-outline cancel-btn col-md-1 text-right font-weight-bold px-0"
            (click)="clearUnMaskedAlternateCardInfo()" *ngIf="!isDisableResetData() && !isfromRunASale"></p>
        </div>
      </div>
      <div class="error-message " *ngIf="(cloudPOSForms.get('routingNumber')?.dirty || cloudPOSForms.get('routingNumber')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="cloudPOSForms.get('routingNumber')?.invalid">
          <span *ngIf="cloudPOSForms.get('routingNumber')?.errors.required">Routing number is required
          </span>
          <span *ngIf="cloudPOSForms.get('routingNumber')?.hasError('pattern')">
          Only numbers are allowed
        </span>
        <span *ngIf="cloudPOSForms.controls['routingNumber'].hasError('minlength')" class="error-message">Enter a minimum of 9 digits.</span>
        </ngb-alert>
      </div>
      </div>
    <div class=" col-md-3 ">
      <div class="form__div mb-0 col-12">
        <input type="text" name="accountNumber" class="form__input" placeholder=" " formControlName="accountNumber" maxlength="17"
          autocomplete="off"   mask="{{maskedAccountFormat}}" [readOnly]="isMaskedCard">
        <label class="form__label" for="accountNumber">
          <h6>{{'htmlText.accountNumber' | translate}}*</h6>
        </label>
      </div>
      <div class="error-message" *ngIf="(cloudPOSForms.get('accountNumber')?.dirty || cloudPOSForms.get('accountNumber')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="cloudPOSForms.get('accountNumber')?.invalid">
          <span *ngIf="cloudPOSForms.get('accountNumber')?.errors.required" class="error-message">
            Account number is required
          </span>
          <span *ngIf="cloudPOSForms.get('accountNumber')?.hasError('pattern')" class="error-message">
            Account Number accepts only numbers
          </span>
          <span *ngIf="cloudPOSForms.get('accountNumber')?.hasError('minlength') || cloudPOSForms.get('accountNumber')?.hasError('maxlength')" class="error-message">
            Account Number should be 4 to 17 digits
          </span>
        </ngb-alert>
      </div>
      
    </div>
    <div class="col-md-3 " *ngIf="isTelSecCode">
        <div class="form__div mb-0 col-12">
      
          <input type="text" name="checkNumber" class="form__input" placeholder=" " formControlName="checkNumber"
            autocomplete="off" mask="000000000000000" maxlength="15">
          <label class="form__label" for="checkNumber">
            <h6>{{'htmlText.checkNumber' | translate}}{{fieldRequiredCheckNumber}}</h6>
          </label>
        </div>
        <div class="error-message" *ngIf="(cloudPOSForms.get('checkNumber')?.dirty || cloudPOSForms.get('checkNumber')?.touched || submitted)">
          <ngb-alert [dismissible]="false" [type]="'danger'"
            *ngIf="cloudPOSForms.get('checkNumber')?.invalid">
            <span *ngIf="cloudPOSForms.get('checkNumber')?.errors.required" class="error-message">Check number is required
            </span>
            <span *ngIf="cloudPOSForms.get('checkNumber')?.hasError('pattern')" class="error-message">
              check Number only accepts numbers</span>
            <span *ngIf="cloudPOSForms.get('checkNumber').hasError('minlength')" class="error-message">Enter a minimum of 1 digits</span>
            <span *ngIf="cloudPOSForms.get('checkNumber').hasError('maxlength')" class="error-message">Enter
              only maximum 15 of digits </span>
            </ngb-alert>
          
        </div>
      </div>
    <div class=" col-md-3" *ngIf="!isCompanyNameRequired && fieldVisibility?.FIRST_NAME">
      <div class="form__div mb-0 col-12">
    
        <input type="text" name="firstName" class="form__input" placeholder=" " formControlName="firstName"
          autocomplete="off" maxlength="100"  trim="blur">
        <label class="form__label" for="firstName">
          <h6>{{'htmlText.firstName' | translate}}{{fieldRequiredFirstName}}</h6>
        </label>
      </div>

      <div class="error-message" *ngIf="(cloudPOSForms.get('firstName')?.dirty || cloudPOSForms.get('firstName')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'"
          *ngIf="cloudPOSForms.get('firstName')?.invalid">
          <span *ngIf="cloudPOSForms.get('firstName')?.errors.required" class="error-message">First name is required
          </span>
          <span *ngIf="cloudPOSForms.get('firstName')?.hasError('pattern')" class="error-message">Invalid first name</span>
            <span *ngIf="cloudPOSForms.get('firstName').hasError('minlength') && !cloudPOSForms.get('firstName')?.hasError('pattern')" class="error-message">Enter a minimum of 1 characters </span>
               <span *ngIf="cloudPOSForms.get('firstName').hasError('maxlength') && !cloudPOSForms.get('firstName')?.hasError('pattern') " class="error-message">Enter
                only  maximum 100 characters</span>
        </ngb-alert>
      </div>
      
      </div>

    <div class=" col-md-3 "  *ngIf="!isCompanyNameRequired &&  fieldVisibility?.LAST_NAME">
      <div class="form__div mb-0 col-12">
    
        <input type="text" name="firstName" class="form__input" placeholder=" "  trim="blur"
          [ngClass]="{'invalid-form-control': (cloudPOSForms.get(['paymentInfo','lastName'])?.errors?.required ||cloudPOSForms.get(['paymentInfo','lastName'])?.touched && cloudPOSForms.get(['paymentInfo','lastName'])?.errors) && submitted}"
          formControlName="lastName" autocomplete="off"  maxlength="100">
        <label class="form__label" for="lastName">
          <h6>{{'htmlText.lname' | translate}}{{fieldRequiredName}}</h6>
        </label>
      </div>

      <div class="error-message" *ngIf="(cloudPOSForms.get('lastName')?.dirty || cloudPOSForms.get('lastName')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'"
          *ngIf="cloudPOSForms.get('lastName')?.invalid">
          <span *ngIf="cloudPOSForms.get('lastName')?.errors.required" class="error-message">Last name is required
          </span>
          <span *ngIf="cloudPOSForms.get('lastName')?.hasError('pattern')" class="error-message">
            Invalid last name </span>
            <span *ngIf="!cloudPOSForms.get('lastName')?.hasError('pattern') && cloudPOSForms.get('lastName').hasError('minlength')" class="error-message">Enter a minimum of 1 characters</span>
               <span *ngIf="!cloudPOSForms.get('lastName')?.hasError('pattern') && cloudPOSForms.get('lastName').hasError('maxlength')" class="error-message">Enter
                only  maximum of 100 characters</span>
        </ngb-alert>
      </div>

    </div>
    <div class=" col-md-3 " *ngIf="isCompanyNameRequired &&  fieldVisibility?.COMPANY_NAME">
      <div class="form__div mb-0 col-12">
    
        <input type="text" name="companyName" class="form__input" placeholder=" " trim="blur"
          [ngClass]="{'invalid-form-control': (cloudPOSForms.get(['paymentInfo','companyName'])?.errors?.required ||cloudPOSForms.get(['paymentInfo','companyName'])?.touched && cloudPOSForms.get(['paymentInfo','companyName'])?.errors) && submitted}"
          formControlName="companyName" autocomplete="off" maxlength="100">
        <label class="form__label" for="companyName">
          <h6>{{'htmlText.companyName' | translate}}{{fieldRequiredName}}</h6>
        </label>
      </div>
    
      <div class="error-message"
        *ngIf="(cloudPOSForms.get('companyName')?.dirty || cloudPOSForms.get('companyName')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="cloudPOSForms.get('companyName')?.invalid">
          <span *ngIf="cloudPOSForms.get('companyName')?.errors.required" class="error-message">Company name is required
          </span>
          <span *ngIf="cloudPOSForms.get('companyName')?.hasError('pattern')" class="error-message">
            Invalid company name </span>
          <span
            *ngIf="!cloudPOSForms.get('companyName')?.hasError('pattern') && cloudPOSForms.get('companyName').hasError('minlength')"
            class="error-message">Enter a minimum of 1 characters</span>
          <span
            *ngIf="!cloudPOSForms.get('companyName')?.hasError('pattern') && cloudPOSForms.get('companyName').hasError('maxlength')"
            class="error-message">Enter
            only maximum of 100 characters</span>
        </ngb-alert>
      </div>
    
    </div>
    <div class=" col-md-3" *ngIf="fieldVisibility?.ZIP">
      <div class="form__div mb-0 col-12">
        <input appZipFormat type="text" name="zipCode" formControlName="zipCode" [attr.maxlength]="zipMaxLength" class="form__input" placeholder=" ">
        <label class="form__label" for="zipCode" >
          <h6>{{'htmlText.zip' | translate}}{{isZipRequired}}</h6>
        </label>
      </div>

      <div class="error-message" *ngIf="showZipError()">
        <ngb-alert [dismissible]="false" [type]="'danger'"
          *ngIf="zipCtrl?.invalid">
          <span *ngIf="zipCtrl?.errors?.['required']" class="error-message">Zip code is required
          </span>
            <span *ngIf="hasZipValidationError()" class="error-message">
              {{'errorMsg.invalidZipCode' | translate }}</span>
        </ngb-alert>
      </div>

    </div>
    <div class="col-md-3"  *ngIf="fieldVisibility?.CITY">
      <div class="form__div mb-0  col-12">
    
        <input type="text" name="firstName" class="form__input" placeholder=" " formControlName="city"  autocomplete="off"
          trim="blur" maxlength="50">
        <label class="form__label" for="city">
          <h6>{{'htmlText.city' | translate}}{{isCityRequired}}</h6>
        </label>
      </div>
      <div class="error-message"
        *ngIf="(cloudPOSForms.get('city')?.dirty || cloudPOSForms.get('city')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="cloudPOSForms.get('city')?.invalid">
          <span *ngIf="cloudPOSForms.get('city')?.errors.required" class="error-message">City is required
          </span>
          <span *ngIf="cloudPOSForms.get('city')?.hasError('pattern')" class="error-message">
            Invalid City </span>
          <span *ngIf="!cloudPOSForms.get('city')?.hasError('pattern') && cloudPOSForms.get('city').hasError('minlength')"
            class="error-message">Enter a minimum of 1 characters </span>
          <span *ngIf="!cloudPOSForms.get('city')?.hasError('pattern') && cloudPOSForms.get('city').hasError('maxlength')"
            class="error-message">Enter a maximum of 50 characters </span>
        </ngb-alert>
      </div>
    
    </div>
    <div class="col-md-3" [ngClass]="cloudPOSForms.get('terminalType')?.value != 'CCD' ? 'mt-2': ''" *ngIf="fieldVisibility?.STATE">
      <div class="form__div col-12 mb-0">
        <ng-select class="ng-expiry-time margin-align" [items]="payaStates" bindValue="state" bindLabel="code"
          [clearable]="false" [searchable]="true" [multiple]="false" formControlName="state" notFoundText="No state found"
          [placeholder]="isStateRequired">
        </ng-select>
      </div>
      <div class="error-message"
        *ngIf="(cloudPOSForms.get('state')?.dirty ||  cloudPOSForms.get('state')?.touched  || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="cloudPOSForms.get('state')?.invalid">
          <span *ngIf="cloudPOSForms.get('state')?.errors.required" class="error-message">state is required
          </span>
        </ngb-alert>
      </div>
    </div>

    <div class="col-md-4 mt-2"  *ngIf="fieldVisibility?.ADDRESS1">
      <div class="form__div mb-0 col-12">
        <input class="form__input" placeholder=" " formControlName="addressOne" maxlength="200"  trim="blur"/>
        <label for="float-input" class="form__label">
          <h6>{{'htmlText.address1' | translate}}{{fieldRequiredNameaddr1}}</h6>
        </label>
      </div>
      <div class="error-message" *ngIf="(cloudPOSForms.get('addressOne')?.dirty || cloudPOSForms.get('addressOne')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'"
          *ngIf="cloudPOSForms.get('addressOne')?.invalid">
          <span *ngIf="cloudPOSForms.get('addressOne')?.errors.required" class="error-message">Address is required
          </span>
          <span *ngIf="cloudPOSForms.get('addressOne')?.hasError('pattern')" class="error-message">
            Address only accepts alphanumeric characters</span>
            <span *ngIf="cloudPOSForms.get('addressOne').hasError('maxlength')" class="error-message">Enter
              only maximum 200 letters </span>
          </ngb-alert>
          </div>
          </div>

    <div class=" col-md-4 mt-2"  *ngIf="fieldVisibility?.ADDRESS2">
      <div class="form__div mb-0  col-12">
        <input class="form__input" placeholder=" " maxlength="200" formControlName="addressTwo"  trim="blur"/>
        <label for="float-input" class="form__label">
          <h6>{{'htmlText.address2' | translate}}{{fieldRequiredNameaddr2}}</h6>
        </label>
      </div>
      
      <div class="error-message"
        *ngIf="(cloudPOSForms.get('addressTwo')?.dirty  || cloudPOSForms.get('addressTwo')?.touched|| submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="cloudPOSForms.get('addressTwo')?.invalid">
          <span *ngIf="cloudPOSForms.get('addressTwo')?.errors.required" class="error-message">Address is required
          </span>
          <span *ngIf="cloudPOSForms.get('addressTwo')?.hasError('pattern')" class="error-message">
            Address only accepts alphanumeric characters</span>
          <span *ngIf="cloudPOSForms.get('addressTwo').hasError('maxlength')" class="error-message">Enter
            only maximum 200 letters </span>
        </ngb-alert>
      </div>
      </div>
      </div>

  <p-divider align="center" styleClass=""  *ngIf="showVerificationSection">
    <span class="mx-1 p-tag">Verification & Validation</span>
    </p-divider>

  <div class="form-row"  *ngIf="showVerificationSection">
    <div class=" col-md-3" *ngIf="fieldVisibility?.DL_NUMBER">
      <div class="form__div col-12 mb-0">
        <input type="text" name="DLNumber" class="form__input" placeholder=" " formControlName="dlNumber"
          autocomplete="off" maxlength="50">
        <label class="form__label" for="DlNumber">
          <h6>{{'htmlText.DLNumber' | translate }}{{fieldRequired}}</h6>
        </label>
      </div>
      <div class="error-message"
        *ngIf="( cloudPOSForms.get('dlNumber')?.dirty ||  cloudPOSForms.get('dlNumber')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="cloudPOSForms.get('dlNumber')?.invalid">
          <span *ngIf="cloudPOSForms.get('dlNumber')?.errors.required" class="error-message">DL is required
          </span>
          <span *ngIf="cloudPOSForms.get('dlNumber')?.hasError('pattern')" class="error-message">
            DL Number only accepts only alphanumeric</span>
          <span *ngIf="cloudPOSForms.get('dlNumber').hasError('minlength')" class="error-message">Enter a minimum of 5
            digits</span>
          <span *ngIf="cloudPOSForms.get('dlNumber').hasError('maxlength')" class="error-message">Enter
            only maximum of 50 digits </span>
        </ngb-alert>
      </div>

    </div>

    <div class="col-md-3" *ngIf="fieldVisibility?.DL_STATE">
      <div class="form__div col-12 mb-0">
        <ng-select class="ng-expiry-time margin-align" [items]="payaStates"  bindValue="state" bindLabel="code" [clearable]="false" [searchable]="true"
          [multiple]="false" formControlName="dlState" notFoundText="No state found" [placeholder]="fieldRequiredState">
        </ng-select>
      </div>
      <div class="error-message" *ngIf="(cloudPOSForms.get('dlState')?.touched || cloudPOSForms.get('dlState')?.dirty || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="cloudPOSForms.get('dlState')?.invalid">
          <span *ngIf="cloudPOSForms.get('dlState')?.errors.required" class="error-message">DL state is required
          </span>
        </ngb-alert>
      </div>
    </div>
    

    <div class=" col-md-3"  *ngIf="dynamicValidationJson?.IDENTITY?.required">
      <div class="form__div col-12 mb-0">
        <input type="text" name="ssn" class="form__input" placeholder="" formControlName="ssn" autocomplete="off"
        mask="0000">
        <label class="form__label" for="ssn">
          <h6>{{'htmlText.ssn' | translate}}*</h6>
        </label>
      </div>
      <div class="error-message "
        *ngIf="(cloudPOSForms.get('ssn')?.dirty || cloudPOSForms.get('ssn')?.touched  || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'">
          <span *ngIf="cloudPOSForms?.hasError('ssnOrBirthYearRequired')" class="error-message">SSN is required
          </span>
          <span *ngIf="cloudPOSForms?.hasError('ssnFormatInvalid')" class="error-message">
            Invalid SSN Number  </span>
          <span *ngIf="cloudPOSForms.get('ssn').hasError('minlength')" class="error-message">Enter a minimum of 4 digits </span>
          <span *ngIf="cloudPOSForms.get('ssn').hasError('maxlength')" class="error-message">Enter
            only maximum of 4 digits </span>
        </ngb-alert>
      </div>
    </div>

    <!-- <p-divider layout="vertical" styleClass="hidden md:flex"><b>OR</b></p-divider> -->

    <div class=" col-md-3"  *ngIf="dynamicValidationJson?.IDENTITY?.required">
      <div class="form__div col-12 mb-0">
        <input type="text" name="BirthYear" class="form__input" placeholder=" " formControlName="birthYear"
          autocomplete="off" maxlength="26" mask="0000">
        <label class="form__label" for="BirthYear">
          <h6>{{'htmlText.BirthYear' | translate}}*</h6>
        </label>
      </div>
      <div class="error-message" *ngIf="(cloudPOSForms.get('birthYear')?.dirty || cloudPOSForms.get('birthYear')?.touched || submitted)">
        <ngb-alert [dismissible]="false" [type]="'danger'">
          <span *ngIf="cloudPOSForms?.hasError('ssnOrBirthYearRequired')" class="error-message">Birth year is required
          </span>
            <span *ngIf="cloudPOSForms.get('birthYear')?.hasError('pattern') || cloudPOSForms.hasError('birthYearFormatInvalid')" class="error-message">
              Enter the complete birth year (e.g, 1978)</span>
        </ngb-alert>
      </div>
    </div>   
    
  </div>

  <!-- <div class="d-flex justify-content-end gap-flex mt-4">
    <button class="btn btn-danger mx-2">Reset</button>
    <button  class="btn btn-primary">Process {{ buttonValue | currency}}</button>
    </div> -->
</form>